import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import {
  Toast
} from 'mint-ui'
import Storage from '../common/storage'

import Main from '../components/main/NIMain.vue'
import County from '../components/ditribution/NICounty.vue'
import Business from '../components/ditribution/NIBusiness.vue'
import District from '../components/ditribution/NIDistrict.vue'
import Charts from '../components/ditribution/NICharts.vue'
import Topup from '../components/topup/NITopup.vue'

const router = new Router({
  routes: [{
    path: '/',
    name: 'main',
    component: Main,
    children: [{
      path: '/county',
      name: 'county',
      component: County
    }, {
      path: '/business',
      name: 'business',
      component: Business
    }, {
      path: '/district',
      name: 'district',
      component: District
    }]
  }, {
    path: '/charts',
    name: 'charts',
    component: Charts
  }, {
    path: '/topup',
    name: 'topup',
    component: Topup
  }]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/' && from.path !== '/') {
    return
  }
  // 判断余额不足逻辑
  if (to.path === '/charts' && from.path === '/district') {
    if (Storage.queryItem('coin') == null || parseInt(Storage.queryItem('coin')) <= 0) {
      Toast({
        message: '余额不足请充值',
        duration: 1000
      })
      let timer = setTimeout(function(argument) {
        next('/topup')
        clearTimeout(timer)
      }, 1000)
      return
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js